import { useLingui } from "@lingui/react/macro";

import type { DataTableInstance } from "../../table-features";
import type { BoolFilterField } from "../types";

import { BaseSwitch } from "../../../../fields/base-switch";
import { getBoolSelected, setBool } from "../tanstack-bridge";

export function BoolEditor<T>({
  table,
  field,
}: {
  table: DataTableInstance<T>;
  field: BoolFilterField<T>;
}) {
  const { t } = useLingui();
  const checked = getBoolSelected(table, field);
  return (
    <label className="flex items-center gap-2.5 text-sm cursor-pointer">
      <BaseSwitch
        checked={checked}
        onCheckedChange={(v) => setBool(table, field, v)}
      />
      {field.toggleLabel ?? t`Enabled`}
    </label>
  );
}
